import c from "./ghl-ui.es1120.js";
const t = (o) => {
  const {
    scrollbarColor: r,
    scrollbarColorHover: l
  } = o;
  return {
    color: r,
    colorHover: l
  };
}, s = {
  name: "Scrollbar",
  common: c,
  self: t
}, n = s;
export {
  n as default,
  t as self
};
